module.exports = __webpack_public_path__ + "img/staff-2013-bowling.d97ae62f.jpg";